export default "__VITE_ASSET__CPrxW7x3__"